import './ifmsSideMenu.css';
import React, { useContext, useEffect, useRef, useState } from 'react';

import { IfmsConfigMenuItem, IfmsConfigOperationMenu } from './config/types';
import ApplicationContext from './ApplicationContext';
import useSideMenuHeightMonitor from './hooks/useSideMenuHeightMonitor';
import multiplewindowsIcon2 from './img/multiplewindows_light.svg';
import multiplewindowsDarkIcon2 from './img/multiplewindows_dark.svg';
import directPrintIcon2 from './img/direct_print2.svg';
import directPrintIcon2_D from './img/direct_print_Dark2.svg';
import disablemultipleWindowIcon from './img/iconbutton-multiplewindows-light-sidebar-disabled.svg';
import disablemultipleWindowDarkIcon from './img/iconbutton-multiplewindows-dark-sidebar-disabled.svg';
import disableDirectPrintIcon from './img/direct_print_disable.svg';
import flagIcon from './img/flag.svg';
import shieldLightIcon2 from './img/cbp_light.svg';
import shieldDarkIcon2 from './img/cbp_dark.svg';
import diamondLightIcon2 from './img/diamond_light.svg';
import diamondDarkIcon2 from './img/diamond_dark.svg';
import selectedDiamondLightIcon2 from './img/diamond_light_hover.svg';
import bulletLightIcon2 from './img/circle_light.svg';
import bulletDarkIcon2 from './img/circle_dark.svg';
import selectedBulletLightIcon2 from './img/circle_light_hover.svg';
import disableBulletLightIcon from './img/sidebar-bullet-disable.svg';
import disableBulletDarkIcon from './img/sidebar-bullet-disable-dark.svg';
import disableShieldLightIcon from './img/sidebar-cbp-light-disabled.svg';
import disableShieldDarkIcon from './img/sidebar-cbp-dark-disabled.svg';

import fastStorage from './fastStorage';
import useGlobalYesNoDialog from './hooks/useGlobalYesNoDialog';
import _ from 'lodash';
import { useHistory } from 'react-router';
import { getRoutePath } from './util/routeUtils';
import { JobNames } from './framework.core/JobNames';
import taskReminderIcon from './img/pin_red.svg';
import { customerShipmentInfoStatus, shipmentStatus } from './components/common/ShipmentStatus';
import { IconTypes } from './config';

export const IfmsSideMenuWidthNumber = 210;
export const IfmsSideMenuWidth = `${IfmsSideMenuWidthNumber}px`;

const ArrowDown = (
  <svg className="ifms-side-menu-downarrow-icon" width="12" height="8" viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg"><path d="M1.008 1.96579L1 1.97279L5.997 6.96678L11 1.96979L10.935 1.90479C7.626 1.98779 4.318 1.99979 1.008 1.96579Z" /></svg>
);
const ArrowUp = (
  <svg className="ifms-side-menu-uparrow-icon" width="12" height="8" viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg"><path d="M10.992 6.46087L11 6.45287L5.996 1.46387L1 6.46987L1.066 6.53487C4.375 6.44687 7.682 6.42987 10.992 6.46087Z" /></svg>
);

// 클릭한 항목에 선택 표시만 하는 오퍼레이션 (URL 기준 선택 표시를 하지 않음)
const ClickSelectOperations = ['Settings', 'Reference Files', 'Business Intelligence'];
// 화살표를 그리지 않는 오퍼레이션
const NoArrowOperations = ['Settings', 'Reference Files'];
// 이 URL 로 끝나는 화면에서는 URL 기준 선택 표시를 하지 않음 (예전 IfmsMain 하이라이트 effect 조건)
const NoHighlightUrlEndings = ['referenceFiles', 'settings', 'BusinessIntelligence'];
// 선택되지 않아도 BL 전용 배경색을 쓰는 리스트 메뉴
const BlJobNames = [JobNames.OIMbl, JobNames.OIHbl, JobNames.OEBook, JobNames.OEMbl, JobNames.OEHbl, JobNames.AIMbl, JobNames.AIHbl, JobNames.AEMbl, JobNames.AEHbl, JobNames.OtherOP];

function getMenuItemKey(operation: string, menuName: string, menuIndex: number): string {
  return operation ? `${operation}-${menuName}-${menuIndex}` : `${menuName}-${menuIndex}`;
}

function getMenuItemName(operation: string, menuName: string, name: string): string {
  return operation ? `${operation}-${menuName}-${name}` : `${menuName}-${name}`;
}

function hasSideMenu(x: IfmsConfigMenuItem): boolean {
  return !!x.items && x.items.length > 0;
}

const getIconSrc = (icon: IconTypes, useDarkMode: boolean): string | undefined => {
  switch (icon) {
    case IconTypes.Flag:
      return flagIcon;
    case IconTypes.Shield:
      return useDarkMode ? shieldDarkIcon2 : shieldLightIcon2;
    case IconTypes.multiplewindows:
      return useDarkMode ? multiplewindowsDarkIcon2: multiplewindowsIcon2;
    default:
      return undefined;
  }
};

// 상세화면 URL 에 따라 기본으로 펼칠 그룹
function toOpenDetailUrlSubGroup(url: string, menuText: React.ReactNode): boolean {
  switch (menuText as string) {
    case 'Accounting Classify':
      return [
        '/accounting/acPrepaidExpenseAdjustment/',
        '/accounting/acDepreciationAdjustment/',
        '/accounting/acAmortizationAdjustment/',
        '/accounting/acBadDebtProcessing/',
        '/accounting/acDistribution/',
        '/accounting/acSalesTaxReturn/',
        '/accounting/acAdvanceSales',
      ].some(path => url.startsWith(path));
    case 'Sales / Cost Batch Recog':
      return ['/accounting/acSalesCostRecog/'].some(path => url.startsWith(path));
    case 'Batch Print':
      return ['/accounting/batchPrint/'].some(path => url.startsWith(path));
    default:
      return false;
  }
}

const ShipmentControlTowerLegend = `
    <div style='display: flex; flex-direction: column; gap: 10px; margin-top: 5px;'>
      <div style="display: flex;"><div style="border:1px solid black; width: 13px; height: 13px; background-color: #${customerShipmentInfoStatus[shipmentStatus.NotDeparted].color}; margin-right: 6px; margin-top:5px;"></div><span style="margin-top:3px;">NOT DEPARTED</span></div>
      <div style="display: flex;"><div style="border:1px solid black; width: 13px; height: 13px; background-color: #${customerShipmentInfoStatus[shipmentStatus.VesselDeparture].color}; margin-right: 6px; margin-top:5px;"></div><span style="margin-top:3px;">VESSEL DEPARTURE</span></div>
      <div style="display: flex;"><div style="border:1px solid black; width: 13px; height: 13px; background-color: #${customerShipmentInfoStatus[shipmentStatus.VesselArrival].color}; margin-right: 6px; margin-top:5px;"></div><span style="margin-top:3px;">VESSEL ARRIVAL</span></div>
      <div style="display: flex;"><div style="border:1px solid black; width: 13px; height: 13px; background-color: #${customerShipmentInfoStatus[shipmentStatus.PickupAvailable].color}; margin-right: 6px; margin-top:5px;"></div><span style="margin-top:3px;">PICKUP AVAILABLE</span></div>
      <div style="display: flex;"><div style="border:1px solid black; width: 13px; height: 13px; background-color: #${customerShipmentInfoStatus[shipmentStatus.GateOut].color}; margin-right: 6px; margin-top:5px;"></div><span style="margin-top:3px;">GATE OUT</span></div>
      <div style="display: flex;"><div style="border:1px solid black; width: 13px; height: 13px; background-color: #${customerShipmentInfoStatus[shipmentStatus.EmptyCntrReturn].color}; margin-right: 6px; margin-top:5px;"></div><span style="margin-top:3px;">EMPTY CNTR RETURN</span></div>
    </div>`;

function IfmsSideMenu({
  parentId,
  menuId,
  menus,
  onMenuItemClicked,
  operation,
  noTitle = false,
  customZIndex = undefined,
  opendOperationData,
}: {
  parentId: string,
  menuId: string,
  menus: IfmsConfigOperationMenu | null | undefined,
  onMenuItemClicked: (menuItem: IfmsConfigMenuItem) => void,
  operation: string,
  noTitle?: boolean,
  customZIndex?: number | undefined,
  opendOperationData?: any
}) {
  useSideMenuHeightMonitor(parentId);
  const history = useHistory();
  const injectMenuId = `${menuId}-inject-container`;
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();
  const appcontext = useContext(ApplicationContext);
  const darkMode = appcontext.useDarkMode;

  const currentUrl = `${history.location.pathname}${history.location.search}`;

  // AES 리스트에서 선택이 바뀌면 다시 그려서 EEI Report / AES Response 활성 여부를 갱신한다
  const [, setAesSelectionVersion] = useState(0);
  useEffect(() => {
    function handleAesSelectionChanged() {
      setAesSelectionVersion(v => v + 1);
    }
    document.addEventListener('aes-selection-changed', handleAesSelectionChanged);
    return () => {
      document.removeEventListener('aes-selection-changed', handleAesSelectionChanged);
    };
  }, []);

  const renderingMenuItems: IfmsConfigMenuItem[] = menus
    ? [
      ...(menus.job ?? []),
      ...(menus.operationReport ?? []),
      ...(menus.preReport ?? []),
      ...(menus.report ?? []),
      ...(menus.moreMenu ?? []),
    ]
    : [];
  const jobItems = menus?.job ?? [];

  // ---------- 그룹 펼침 상태 (릴리즈와 같은 규칙) ----------
  // 릴리즈는 메뉴 구성(오퍼레이션 / 다크모드 / menus 내용)이 바뀔 때만 사이드 메뉴를 새로 그렸다.
  //  - 새로 그릴 때: 기본 그룹만 펼침 (More Menu, Accounting 의 Financial Report, 상세화면 URL 그룹, 현재 URL 이 하위 메뉴인 그룹)
  //  - 메뉴 구성은 그대로이고 URL 만 바뀔 때: 펼쳐 둔 그룹은 그대로 두고, 현재 URL 이 하위 메뉴인 그룹만 추가로 펼침
  //  - 그 사이 사용자가 접거나 펼친 것은 유지
  const currentUrlGroupIndex = renderingMenuItems.findIndex(x => x.items && x.items.some(item => item.link === currentUrl));

  function isDefaultOpen(item: IfmsConfigMenuItem, index: number) {
    if (!hasSideMenu(item)) return false;
    return item.text === 'More Menu'
      || (operation === 'Accounting' && item.text === 'Financial Report')
      || toOpenDetailUrlSubGroup(currentUrl, item.text)
      || index === currentUrlGroupIndex;
  }

  // 메뉴 구성이 바뀌었는지 깊은 비교로 판단해 버전을 올린다
  const menuStructureRef = useRef<{ snapshot: any, version: number }>({ snapshot: undefined, version: 0 });
  const menuStructure = { operation, darkMode, menus };
  if (!_.isEqual(menuStructure, menuStructureRef.current.snapshot)) {
    menuStructureRef.current = { snapshot: _.cloneDeep(menuStructure), version: menuStructureRef.current.version + 1 };
  }
  const menuStructureVersion = menuStructureRef.current.version;

  //  expanded    : 펼친 그룹 (index → 펼침 여부). 한 번이라도 펼쳐진 그룹만 key 가 있다.
  //  listArrowUp : 현재 리스트 메뉴를 다시 클릭해 그 아래 More Menu 를 접은 상태 (index → 접힘 여부)
  //  operation / texts : 이 상태를 만들 때의 오퍼레이션과 메뉴 이름 목록 (메뉴 구성이 바뀔 때 펼침 상태를 이름으로 옮기는 데 쓴다)
  // (Settings 계열의 클릭 선택 표시는 state 가 아니라 예전처럼 DOM 에 직접 한다 - handleClick 참고)
  const [userState, setUserState] = useState({
    version: -1,
    url: '',
    operation: '',
    texts: [] as string[],
    expanded: {} as Record<number, boolean>,
    listArrowUp: {} as Record<number, boolean>,
  });

  const renderingTexts = renderingMenuItems.map(x => String(x.text));

  let currentUserState = userState;
  if (currentUserState.version !== menuStructureVersion) {
    const expanded: Record<number, boolean> = {};
    // 같은 오퍼레이션 안에서 메뉴 구성만 바뀐 경우 (More Menu 가 붙거나 빠지는 등):
    // 사용자가 펼치거나 접어 둔 그룹은 위치가 달라져도 이름으로 찾아 그대로 유지한다
    if (currentUserState.operation === operation) {
      Object.entries(currentUserState.expanded).forEach(([prevIndex, value]) => {
        const index = renderingTexts.indexOf(currentUserState.texts[Number(prevIndex)]);
        if (index !== -1 && hasSideMenu(renderingMenuItems[index])) expanded[index] = value;
      });
    }
    renderingMenuItems.forEach((item, index) => {
      if (isDefaultOpen(item, index)) expanded[index] = true;
    });
    currentUserState = { version: menuStructureVersion, url: currentUrl, operation, texts: renderingTexts, expanded, listArrowUp: {} };
  } else if (currentUserState.url !== currentUrl) {
    currentUserState = {
      ...currentUserState,
      url: currentUrl,
      expanded: currentUrlGroupIndex !== -1 ? { ...currentUserState.expanded, [currentUrlGroupIndex]: true } : currentUserState.expanded,
    };
  }

  // 위에서 새로 계산한 상태를 저장 (같으면 아무것도 안 함)
  useEffect(() => {
    if (currentUserState !== userState) setUserState(currentUserState);
  });

  function isExpanded(item: IfmsConfigMenuItem, index: number) {
    if (!hasSideMenu(item)) return false;
    return !!currentUserState.expanded[index];
  }

  // ---------- 선택 표시 (예전 IfmsMain 하이라이트 effect 와 같은 규칙) ----------
  // Settings 계열 사이드 메뉴는 예전에도 IfmsMain 하이라이트 대상이 아니었다 (클릭 선택만 사용)
  const isClickSelectOperation = ClickSelectOperations.includes(operation);
  const useUrlHighlight = !isClickSelectOperation && !NoHighlightUrlEndings.some(x => currentUrl.endsWith(x));
  let selectedIndex = -1;
  let selectedParentIndex = -1;
  let selectedChildIndex = -1;

  if (useUrlHighlight) {
    // 1) 현재 URL 의 리스트 메뉴
    selectedIndex = jobItems.findIndex(x => x.link?.includes(currentUrl));

    if (selectedIndex === -1) {
      // 2) 펼친 그룹(More Menu 제외) 안에서 URL 이 맞는 첫 하위 메뉴
      const openedGroupIndexes = renderingMenuItems
        .map((item, index) => index)
        .filter(index => isExpanded(renderingMenuItems[index], index) && !renderingMenuItems[index].metadata?.hideMenu);

      for (const index of openedGroupIndexes) {
        const childIndex = jobItems[index]?.items?.findIndex(x => x.link && currentUrl.includes(x.link)) ?? -1;
        if (childIndex !== -1) {
          selectedParentIndex = index;
          selectedChildIndex = childIndex;
          break;
        }
      }

      // 3) 펼친 그룹이 하나도 없으면 More Menu 안에서 URL(쿼리 제외)이 맞는 하위 메뉴
      if (openedGroupIndexes.length === 0) {
        const moreMenuIndex = jobItems.findIndex(x => x.text === 'More Menu');
        if (moreMenuIndex !== -1) {
          const childIndex = jobItems[moreMenuIndex].items?.findIndex(x => x.link && currentUrl.includes(x.link.split('?')[0])) ?? -1;
          if (childIndex !== -1) {
            selectedParentIndex = moreMenuIndex;
            selectedChildIndex = childIndex;
          }
        }
      }
    }
  }

  // ---------- AES 메뉴 활성/비활성 ----------
  const aesTargetNames = ['aesEei', 'aesResponse'];
  const aesHasSentDate = fastStorage['aes-selected-has-sent-date'] ?? false;

  // ---------- 클릭 ----------
  function setExpanded(index: number, value: boolean) {
    setUserState({ ...currentUserState, expanded: { ...currentUserState.expanded, [index]: value } });
  }

  function handleClick(item: IfmsConfigMenuItem, index: number) {
    // 대상 레코드가 없는 화면(Batch Print 등)에서 막아 둔 항목은 눌러도 반응하지 않는다 (IfmsMain 에서 지정)
    if (item.metadata?.noClick) return;

    // Settings / Reference Files / Business Intelligence: 클릭한 항목만 선택 표시
    // 이 화면들은 다시 열릴 때 자기 코드에서 사이드 메뉴 항목을 DOM 으로 직접 칠하므로,
    // 선택 표시도 예전처럼 DOM 에서 '칠해진 것 모두 지우고 → 클릭한 것 칠하기'로 한다.
    // (React 가 그리는 className 은 이 화면들에서 항상 기본 클래스라 React 가 다시 덮어쓰지 않는다)
    if (isClickSelectOperation) {
      const alreadySelected = document.querySelectorAll(`.${selectedSideMenuClassName}`);
      for (let i = 0; i < alreadySelected.length; ++i) {
        alreadySelected[i].className = sideMenuItemClassName;
      }
      const clickedDom = document.getElementById(getMenuItemKey(operation, 'ifms-side-menu', index));
      if (clickedDom) clickedDom.className = selectedSideMenuClassName;
      onMenuItemClicked(item);
      return;
    }

    // 하위 항목이 있는 그룹: 접기/펼치기
    if (hasSideMenu(item)) {
      setExpanded(index, !isExpanded(item, index));
      return;
    }

    // 현재 열린 리스트 메뉴를 다시 클릭하면 그 아래 More Menu 를 접기/펼치기
    if (!_.isEmpty(item.moreMenuJobName) && item.level === 0) {
      const windowURL = `${window.location.pathname}${window.location.search}`;
      if (windowURL === item.link) {
        const moreMenuIndex = renderingMenuItems.findIndex(m => m.text === 'More Menu');
        if (moreMenuIndex === -1) return;

        const folded = !!currentUserState.listArrowUp[index];
        setUserState({
          ...currentUserState,
          expanded: { ...currentUserState.expanded, [moreMenuIndex]: folded },
          listArrowUp: { ...currentUserState.listArrowUp, [index]: !folded },
        });
        return;
      }
    }

    onMenuItemClicked(item);
  }

  async function handleClickSubMenu(x: IfmsConfigMenuItem) {
    // 대상 레코드가 없는 화면(Batch Print 등)에서 막아 둔 항목은 눌러도 반응하지 않는다 (IfmsMain 에서 지정)
    if (x.metadata?.noClick) return;

    if (x.moreMenuJobName) {
      // 상세화면이 Add 모드면 More Menu 클릭 불가
      if (x.metadata?.operationMode === 'add') {
        return;
      }

      // 상세화면에 저장 안 된 변경이 있으면 확인
      if (opendOperationData) {
        let isDirty = false;
        _.forOwn(fastStorage, (val, key) => {
          if (!key.endsWith(getRoutePath(currentUrl))) return;
          if (val && val.isDirty !== undefined && val.isDirty === true) isDirty = true;
        });

        if (showGlobalYesNoDialog && isDirty) {
          const doClose = await showGlobalYesNoDialog(
            <div>
              <h3>Open {x.text} without saving <span style={{ color: 'red', fontWeight: 'bold' }}>CHANGES</span>?</h3>
            </div>
          );
          if (!doClose) return;
        }
      }
    }
    onMenuItemClicked(x);
  }

  // ---------- 렌더링 ----------
  const sideMenuItemClassName = !darkMode ? 'ifms-side-menu-item-withscroll' : 'ifms-side-menu-item-withscroll-darkmode';
  const selectedSideMenuClassName = !darkMode ? 'ifms-side-menu-item-selected-onclick' : 'ifms-side-menu-item-selected-onclick-darkmode';
  const selectedBLSideMenuClassName = !darkMode ? 'ifms-side-menu-item-selected-bl-onclick' : 'ifms-side-menu-item-selected-onclick-bl-darkmode';
  const sideCaptionClassName = !darkMode ? 'ifms-side-menu-item-withscroll-caption' : 'ifms-side-menu-item-withscroll-caption-darkmode';
  const extendedSubMenuClassName = !darkMode ? 'ifms-sub-menu-item-withscroll' : 'ifms-sub-menu-item-withscroll-darkmode';
  const noClickEventSubMenuClassName = !darkMode ? 'ifms-sub-menu-item-withscroll-noclickevent' : 'ifms-sub-menu-item-withscroll-noclickevent-darkmode';
  const selectedSubMenuClassName = !darkMode ? 'ifms-sub-menu-item-selected-onclick' : 'ifms-sub-menu-item-selected-onclick-darkmode';
  const multipleWindowsIcon = !darkMode ? multiplewindowsIcon2 : multiplewindowsDarkIcon2;

  function renderSubMenuItems(parent: IfmsConfigMenuItem, parentIndex: number, parentKey: string) {
    const items = parent.items ?? [];
    const shownTopLineColors = new Set<string>();
    const elements: React.ReactNode[] = [];

    items.forEach((sx, i) => {
      const isAddMode = sx.metadata?.operationMode === 'add';

      // topLineColor 별 첫 항목 위에만 구분선
      if (sx.topLineColor && !shownTopLineColors.has(sx.topLineColor)) {
        shownTopLineColors.add(sx.topLineColor);
        elements.push(
          <div key={`${parentKey}-topline-${i}`} id='ifms-side-menu-extended-topline'
            style={{ borderTop: `2px solid ${sx.topLineColor}`, marginLeft: '26px', marginRight: '12px' }} />
        );
      }

      const isUrlSelected = parentIndex === selectedParentIndex && i === selectedChildIndex;
      // URL 기준 선택 표시를 하지 않는 화면에서는 pathname 이 같은 항목을 선택 표시 (예전 injectSubMenu 동작)
      const isPathSelected = !useUrlHighlight && window.location.pathname === sx.link;

      let className = (parent.text === 'More Menu' && isAddMode) ? noClickEventSubMenuClassName : extendedSubMenuClassName;
      className += ` parent-index${parentIndex}`;
      if (isUrlSelected || isPathSelected) className = `${selectedSubMenuClassName} parent-index${parentIndex}`;

      const bulletIcon = darkMode ? bulletDarkIcon2 : (isUrlSelected ? selectedBulletLightIcon2 : bulletLightIcon2);
      const disableBulletIcon = darkMode ? disableBulletDarkIcon : disableBulletLightIcon;

      let content: React.ReactNode;
      if (!isAddMode) {
        if (sx.metadata?.isDirectPrint) {
          content = <>{sx.text} <img width='15px' height='15px' src={!darkMode ? directPrintIcon2 : directPrintIcon2_D} alt='' /></>;
        } else if (sx.iconImg) {
          const iconSrc = getIconSrc(sx.iconImg as IconTypes, darkMode);
          content = iconSrc
            ? <>
              <img style={{ marginRight: '2px' }} src={bulletIcon} alt='' />{sx.text}
              {' '}<img width='16px' height='16px' style={{ marginLeft: '8px', marginBottom: '2px' }} src={iconSrc} alt='' />
              {sx.subMenu ? <>{' '}<img style={{ marginLeft: '12px', marginBottom: '2px' }} src={multipleWindowsIcon} alt='' /></> : null}
            </>
            : null;
        } else {
          content = <><img style={{ marginRight: '2px' }} src={bulletIcon} alt='' />{sx.text}</>;
        }
      } else {
        // Add 모드: 비활성 아이콘
        if (sx.metadata?.isDirectPrint) {
          content = <><img style={{ marginRight: '2px' }} src={disableBulletIcon} alt='' />{sx.text} <img width='15px' height='15px' src={disableDirectPrintIcon} alt='' /></>;
        } else if (sx.iconImg == IconTypes.Shield) {
          content = <>
            <img style={{ marginRight: '2px' }} src={disableBulletIcon} alt='' />{sx.text}
            {' '}<img width='16px' height='16px' style={{ marginLeft: '8px', marginBottom: '2px' }} src={darkMode ? disableShieldDarkIcon : disableShieldLightIcon} alt='' />
            {sx.subMenu ? <>{' '}<img style={{ marginLeft: '12px', marginBottom: '2px' }} src={darkMode ? disablemultipleWindowDarkIcon : disablemultipleWindowIcon} alt='' /></> : null}
          </>;
        } else {
          content = <><img style={{ marginRight: '2px' }} src={disableBulletIcon} alt='' />{sx.text}</>;
        }
      }

      const subMenuItemKey = getMenuItemKey('', parentKey, i);
      elements.push(
        <div key={subMenuItemKey} id={subMenuItemKey} className={className}
          style={sx.textColor && !isAddMode ? { color: sx.textColor } : undefined}
          onClick={() => handleClickSubMenu(sx)}>
          {content}
        </div>
      );
    });

    return elements;
  }

  function renderMenuItems() {
    const elements: React.ReactNode[] = [];
    let lastGroupLineColor: string | null = null;

    renderingMenuItems.forEach((menuItem, i) => {
      const menuItemKey = getMenuItemKey(operation, 'ifms-side-menu', i);
      const isGroup = hasSideMenu(menuItem);
      const expanded = isExpanded(menuItem, i);

      if (menuItem.topLineColor && lastGroupLineColor !== menuItem.topLineColor) {
        elements.push(
          <div key={`${menuItemKey}-topline`} id='ifms-side-menu-topline'
            style={{ borderTop: `1px solid ${menuItem.topLineColor}`, marginLeft: '16px', width: menuItem.topLineShort ? '105px' : undefined }} />
        );
        lastGroupLineColor = menuItem.topLineColor;
      }

      // 리스트 아래에 붙는 More Menu 는 제목 줄 없이 항목만 보이게 한다
      if (!menuItem.metadata?.hideMenu) {
        // ----- class -----
        let className = sideMenuItemClassName;
        if (expanded) className += ` ifms-side-menu-item-opend-${i}`;

        const isUrlSelected = i === selectedIndex;
        if (useUrlHighlight) {
          if (isUrlSelected) className = selectedSideMenuClassName;
          else if (i < jobItems.length && menuItem.moreMenuJobName && BlJobNames.includes(menuItem.moreMenuJobName)) className = selectedBLSideMenuClassName;
        }

        // ----- style -----
        const style: React.CSSProperties = {};
        if (menuItem.textColor) style.color = menuItem.textColor;
        if (menuItem.disable) {
          style.opacity = '0.2';
          style.pointerEvents = 'none';
        }
        if (menuItem.name && aesTargetNames.includes(menuItem.name)) {
          style.opacity = aesHasSentDate ? '' : '0.2';
          style.pointerEvents = aesHasSentDate ? undefined : 'none';
        }

        // ----- content -----
        const diamond = <img style={{ marginRight: '4px' }} src={darkMode ? diamondDarkIcon2 : (useUrlHighlight && isUrlSelected ? selectedDiamondLightIcon2 : diamondLightIcon2)} alt='' />;
        const showArrow = (isGroup || (menuItem.moreMenuJobName && menuItem.level === 0)) && !NoArrowOperations.includes(operation);
        const iconSrc = menuItem.iconImg ? getIconSrc(menuItem.iconImg as IconTypes, darkMode) : undefined;
        const iconImg = iconSrc ? <img width='16px' height='16px' style={{ marginLeft: '8px', marginBottom: '2px' }} src={iconSrc} alt='' /> : null;
        const subMenuImg = menuItem.subMenu && !menuItem.nonSubMenuIcon
          ? <>{' '}<img style={{ marginLeft: '12px', marginBottom: '2px' }} src={multipleWindowsIcon} alt='' /></>
          : null;

        let content: React.ReactNode;
        if (isGroup) {
          if (expanded) {
            content = <>{diamond}{menuItem.text} {ArrowUp}</>;
          } else if (showArrow || currentUserState.expanded[i] !== undefined) {
            content = <>{diamond}{menuItem.text} {ArrowDown}{subMenuImg}</>;
          } else {
            content = <>{diamond}{menuItem.text}{iconImg}{subMenuImg}</>;
          }
        } else if (currentUserState.listArrowUp[i] !== undefined) {
          content = <>{diamond}{menuItem.text} {currentUserState.listArrowUp[i] ? ArrowUp : ArrowDown}</>;
        } else if (showArrow) {
          content = <>{diamond}{menuItem.text} {ArrowDown}{subMenuImg}</>;
        } else if (menuItem.metadata?.isDirectPrint) {
          content = <>{diamond}{menuItem.text}{iconImg} <img style={iconImg ? { marginLeft: '12px' } : undefined} src={multipleWindowsIcon} alt='' />{subMenuImg}</>;
        } else if (menuItem.metadata?.isTask) {
          content = <>{diamond}{menuItem.text}{iconImg} <img width='12px' height='12px' src={taskReminderIcon} alt='' />{subMenuImg}</>;
        } else {
          content = <>{diamond}{menuItem.text}{iconImg}{subMenuImg}</>;
        }

        elements.push(
          <div key={menuItemKey} id={menuItemKey} className={className} style={style}
            // 예전처럼 DOM 프로퍼티(expando)로 name 을 단다
            ref={el => { if (el && menuItem.name) (el as any).name = getMenuItemName(operation, 'ifms-side-menu', menuItem.name); }}
            onClick={() => handleClick(menuItem, i)}>
            {content}
          </div>
        );
      }

      if (expanded) {
        elements.push(...renderSubMenuItems(menuItem, i, menuItemKey));
      }
    });

    if (operation === 'Shipment Control Tower') {
      elements.push(
        <div key='shipment-control-tower-legend' className={sideCaptionClassName} style={{ marginTop: '50px' }}
          dangerouslySetInnerHTML={{ __html: ShipmentControlTowerLegend }} />
      );
    }

    return elements;
  }

  const displayOperation = operation !== 'Standalone' ? operation : '';

  const menuContainerStyle: React.CSSProperties = {};
  if (customZIndex !== undefined) {
    menuContainerStyle['zIndex'] = customZIndex;
  }

  const sideMenuClassName = !darkMode ? 'ifms-side-menu-withscroll' : 'ifms-side-menu-withscroll-darkmode';

  return (
    <div id={menuId} className="ifms-side-menu-main" style={menuContainerStyle}>
      {!noTitle &&
        <div className={!darkMode ? "ifms-side-menu-operation-title" : "ifms-side-menu-operation-title-darkmode"}>
          {displayOperation}
        </div>
      }
      <div className={sideMenuClassName}>
        <div style={{ height: '14px' }}>
          <div style={{ borderTop: '3px solid #dc3545', height: '2px', marginLeft: '16px', marginRight: '12px', position: 'relative', top: '6px' }}></div>
        </div>
        <div id={injectMenuId}>
          {renderMenuItems()}
        </div>
      </div>
    </div>
  );
}

export default React.memo(IfmsSideMenu);